import { render } from "./MediaflowSourcesDock.vue?vue&type=template&id=0a81a9c6"
import script from "./MediaflowSourcesDock.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowSourcesDock.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Mediaflow/MediaflowSourcesDock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a81a9c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a81a9c6', __exports__)) {
    api.reload('0a81a9c6', __exports__)
  }
  
  module.hot.accept("./MediaflowSourcesDock.vue?vue&type=template&id=0a81a9c6", () => {
    api.rerender('0a81a9c6', render)
  })

}


export default __exports__